import { render, staticRenderFns } from "./MyAccountUploads.vue?vue&type=template&id=2738f4ed"
import script from "./MyAccountUploads.vue?vue&type=script&lang=js"
export * from "./MyAccountUploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports